export const DEFAULT_MODULE_NAME = 'main';
export const DEFAULT_MODULE_TITLE = 'Main';
